import * as React from 'react';
import { Res } from 'core/api';
import { Dialog, DialogFooter, DialogHeader, DialogBody } from './Dialog';
import Button from './Button';
import { whenEnterKey, whenEscKey } from './Utils';

interface Props extends React.PropsWithChildren {
	title: string;
	kind?: 'base' | 'large' | 'xlarge';
	onCancel: () => void;
	onOK: () => void;
	onKeyDown?: (e: React.KeyboardEvent<any>) => void;
	acceptOnEnter?: boolean;
	cancelOnEsc?: boolean;
	bodyHeight?: React.CSSProperties['height']
}


const ConfirmDialog = React.forwardRef<HTMLDivElement, Props>((props, ref) => {

	const acceptOnEnter = props.acceptOnEnter || typeof props.acceptOnEnter === 'undefined';
	const cancelOnEsc = props.cancelOnEsc || typeof props.cancelOnEsc === 'undefined';

	const onDefaultKeyDown = (e: React.KeyboardEvent<any>) => {

		if (acceptOnEnter)
			whenEnterKey(props.onOK)(e);

		if (cancelOnEsc)
			whenEscKey(props.onCancel)(e);

		if (props.onKeyDown)
			props.onKeyDown(e);
	};

	return <Dialog ref={ref} kind={props.kind} onKeyDown={onDefaultKeyDown}>
		<DialogHeader>
			<h4 className='modal-title'>{props.title}</h4>
		</DialogHeader>
		<DialogBody style={{ height: props.bodyHeight }}>
			{props.children}
		</DialogBody>
		<DialogFooter>
			<Button buttonStyle='info' className='icon ok' onClick={props.onOK}>{Res.Common.OK_BTN()}</Button>
			<Button className='icon cancel' onClick={props.onCancel}>{Res.Common.CANCEL_BTN()}</Button>
		</DialogFooter>
	</Dialog>;
});

export default ConfirmDialog;
